var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.model)?_c('div',{staticClass:"dcv_container"},[(_vm.fullorder)?_c('order',{attrs:{"order":_vm.fullorder}}):_vm._e(),_vm._v(" "),(this.model.offer.distributed_product.agency)?_c('agency',{attrs:{"agency":this.model.offer.distributed_product.agency}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f2581ee","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Demands/ModelDomiciliationContractValidation.vue
// module id = 1738
// module chunks = 0